import React from 'react';

const Pause = ({className, style}) => (
  <div className={className} style={{...style}} >
    <svg version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 357 357" xmlSpace="preserve"><path d="M25.5 357h102V0h-102v357zm204-357v357h102V0h-102z" fill="#fff" /></svg>
  </div>
);

Pause.defaultProps = {
  style: {
  },
};

export default Pause;
